import { connect } from 'react-redux';
import GroupList from '../../components/group/GroupList';
import { list, allData } from '../../actions/group';

const mapStateToProps = ({ group, faculty, cathedra }) => ({
  list: group.list,
  yearList: group.years,
  facultyList: faculty.list,
  cathedraList: cathedra.list,
  isLoading: group.isLoading,
});

const mapDispatchToProps = dispatch => ({
  didMount: () => dispatch(allData()),
  groupList: data => dispatch(list(data.year, data.faculty, data.cathedra)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GroupList);
